<template>
      <v-card class="mx-auto" shaped elevation="7">
            <v-card-title>
                  Asignación De Beneficio Complementario
            </v-card-title>
            <v-card-text>
                  <v-container fluid grid-list-sm>
                        <v-row dense>
                              <v-col cols="12">
                                    <ModalBeneficioAseguradoComponent :obModal="obModal" :listGeneral="listGeneral" />
                              </v-col>
                        </v-row>

                        <v-form ref="form">

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Seguro *" color="textbox"
                                                v-model="obSearch.idSeguro" @change="onListarProducto"
                                                :items="_.filter(listGeneral.listSeguro,(v)=>{ return !_.isNull(v.value) })" 
                                                :rules="requeridoRegla" outlined dense />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Producto *" color="textbox" v-model="obSearch.idProducto"
                                                :items="listGeneral.listProducto" outlined dense 
                                                :rules="requeridoRegla"/>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete label="Beneficios *" color="textbox" v-model="obSearch.idBeneficio" 
                                                :items="_.filter(listGeneral.listBeneficio,(v)=>{return !_.isNull(v.value)})" outlined dense 
                                                :rules="requeridoRegla"/>
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.open"
                                                :return-value.sync="obSearch.fechaDesde" persistent width="340px">
                                                <template v-slot:activator="{ on }">
                                                      <v-text-field color="textbox" v-model="obSearch.fechaDesde"
                                                            label="Fecha Compra Certificado Desde *" prepend-inner-icon="event" readonly
                                                            outlined dense v-on="on" :rules="requeridoRegla" />
                                                </template>
                                                <v-date-picker color="primary" v-model="obSearch.fechaDesde"
                                                      scrollable locale="es">
                                                      <v-spacer></v-spacer>
                                                      <v-btn outlined dense rounded color="danger"
                                                            @click="objDate.desde.open = false" v-html="'Salir'">
                                                      </v-btn>
                                                      <v-btn rounded dark color="primary"
                                                            @click="$refs.dialogFechaDesde.save(obSearch.fechaDesde);"
                                                            v-html="'Guardar Fecha'"></v-btn>
                                                </v-date-picker>
                                          </v-dialog>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-dialog ref="dialogFechaHasta" v-model="objDate.hasta.open"
                                                :return-value.sync="obSearch.fechaHasta" persistent width="340px">
                                                <template v-slot:activator="{ on }">
                                                      <v-text-field color="textbox" v-model="obSearch.fechaHasta"
                                                            label="Fecha Compra Certificado Hasta *" prepend-inner-icon="event" readonly
                                                            outlined dense v-on="on" :rules="requeridoRegla" />
                                                </template>
                                                <v-date-picker color="primary" v-model="obSearch.fechaHasta"
                                                      scrollable locale="es">
                                                      <v-spacer></v-spacer>
                                                      <v-btn outlined dense rounded color="danger"
                                                            @click="objDate.hasta.open = false" v-html="'Salir'">
                                                      </v-btn>
                                                      <v-btn rounded dark color="primary"
                                                            @click="$refs.dialogFechaHasta.save(obSearch.fechaHasta);"
                                                            v-html="'Guardar Fecha'"></v-btn>
                                                </v-date-picker>
                                          </v-dialog>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-text-field label="N° de Asegurados que se Beneficiaran *" color="textbox" 
                                                        v-model="obSearch.nroAsegurados" :rules="requeridoRegla" outlined dense/>
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-text-field label="Rango de Valor de Beneficios Desde *" color="textbox" 
                                                        v-model="obSearch.rangoValorDesde" :rules="requeridoRegla" outlined dense/>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-text-field label="Rango de Valor de Beneficios Hasta *" color="textbox" 
                                                        v-model="obSearch.rangoValorHasta" :rules="requeridoRegla" outlined dense/>
                                    </v-col>
                                    <v-col>
                                          <v-tooltip top color="primary">
                                                <template v-slot:activator="{ on }">
                                                      <v-btn fab dark small color="primary" @click="onListarCertificados" v-on="on"
                                                            :disabled="disabled">
                                                            <v-icon dark>search</v-icon>
                                                      </v-btn>
                                                </template>
                                                <span>Buscar</span>
                                          </v-tooltip>
                                    </v-col>
                              </v-row>

                        </v-form>

                        <v-row dense>
                              <v-col v-if="_.size(listDetalle) == 0" cols="12" sm="6"/>
                              <v-col v-else cols="12" sm="6">
                                    <v-btn rounded color="primary" dark @click="enviar">Procesar</v-btn>
                              </v-col>
                              <v-col cols="12" sm="6">
                                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable
                                    prepend-inner-icon="search" dense/>
                              </v-col>
                        </v-row>

                        <v-row dense>
                              <v-col cols="12">
                                    <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera"
                                          :items="listGeneral.detalle" class="elevation-3">
                                    
                                          <template v-slot:item.ver="{ item }">
                                                <v-btn class="ma-2" text icon color="primary" @click="ver(item)" :disabled="item.verBene">
                                                      <v-icon small>visibility</v-icon>
                                                </v-btn>
                                          </template>

                                          <template v-slot:item.name="{ item }">
                                                <v-simple-checkbox :ripple="false" v-model="item.check" color="textbox" :disabled="item.isCheck"></v-simple-checkbox>
                                          </template>
                                          
                                          <template v-slot:no-results>
                                                Tu búsqueda de "<span v-text="obSearch.search"></span>" no arrojó resultados.
                                          </template>
                                    </v-data-table>
                              </v-col>
                        </v-row>
                  </v-container>
            </v-card-text>
      </v-card>
</template>

<script>
      export default {
            name: 'AsignacionBeneficioComplementarioView',
            components:{
                  ModalBeneficioAseguradoComponent:() => import('@/components/beneficio/ModalBeneficioAseguradoComponent.vue')
            }, 
            data: () => ({
                  listGeneral:{},
                  parametros:{},
                  obSearch:{
                        search:'',
                        idSeguro:null,
                        idProducto:null,
                        idBeneficio:null,
                        fechaDesde:moment().format('YYYY-MM-DD'),
                        fechaHasta:moment().format('YYYY-MM-DD'),
                        rangoValorDesde:null,
                        rangoValorHasta:null,
                        nroAsegurados:0,
                        idEstado:null
                  },
                  objDate:{
                        desde:{open:false},
                        hasta:{open:false}
                  },
                  obModal:{
                        titulo:'',
                        search:'',
                        open:false
                  },
                  disabled:false

            }),
            created(){
                  var error = 'E';

                  axios.post(`${BASE_URI}administrador/asignacion-beneficio-complementario/cargaGeneral`)
                        .then((r) =>{
                              if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                              if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                    this.$set(this,'listGeneral', r.data.data.listas);
                                    this.$set(this,'parametros', r.data.data.parametros);
                                    this.obSearch.idEstado = _.toString(this.parametros.id_estado_default);
                                    this.obSearch.idSeguro = _.get(_.find(this.listGeneral.listSeguro,(v)=>{ return !_.isNull(v.value) }),'value',null);
                                    return this.onListarProducto('L');
                        })
                        .catch((e) =>{
                              mensajesAlerta(e, error);
                        });
            },
            computed:{
                  listDetalle(){
                        var l = _.cloneDeep(_.get(this.listGeneral,'detalle',[]));
                        l = _.filter(l,{'check':true});
                        return _.map(l,_.partialRight(_.pick,['idCertificado','idPoliza','idCliente']));
                  },
                  validTotalItems(){
                        return _.size(this.listDetalle) > _.toNumber(this.obSearch.nroAsegurados) ? true : false;
                  }
            },
            methods:{
                  onListarProducto(ev){
                        if(!_.isUndefined(ev)){
                              var error = 'E';
                              var o = _.merge({opcion:'L_COMBO'},_.pick(this.obSearch,['idSeguro','idEstado']));

                              this.listGeneral.listProducto = [];
                              axios.post(`${BASE_URI}administrador/producto/listar`,o)
                                    .then((r) =>{
                                          if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                          if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                                this.listGeneral.listProducto = _.map(_.cloneDeep(r.data.data),(v)=>{
                                                      return {
                                                            value:v.id_producto,
                                                            text:v.nombre_producto
                                                      }
                                                });
                                    })
                                    .catch((e) =>{
                                          mensajesAlerta(e, error);
                                    });
                        }
                  },
                  onListarCertificados(ev){
                        try {
                              if(!_.isUndefined(ev)){
                                    if(!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                                          this.disabled = true;
                                          var error = 'E';
                                          var o = _.merge({opcion:'L_CERTIFICADO'},_.omit(this.obSearch,'search'))
      
                                          this.listGeneral.detalle = [];
                                          axios.post(`${BASE_URI}administrador/asignacion-beneficio-complementario/listar`,o)
                                                .then((r) =>{
                                                      if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                                      if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                                            var l = _.cloneDeep(r.data.data);
                                                            
                                                            l = _.map(l,(v,k)=>{
                                                                        v.n = k+1;
                                                                        v.comision  = _.round(_.toNumber(v.comision),2);
                                                                        v.verBene   = _.toNumber(_.get(v,'verBene',0)) == 0 ? true : false;
                                                                        v.isCheck   = _.toNumber(_.get(v,'isCheck',0)) == 1 ? true : false;
                                                                        v.check     = false;
                                                                        return v;
                                                                  });
                                                            this.listGeneral.detalle = l;
                                                            this.disabled = false;
                                                })
                                                .catch((e) =>{
                                                      mensajesAlerta(e, error);
                                                      this.disabled = false;
                                                });
                              }
                        } catch (ex) {
                              mensajesAlerta(ex, 'I');
                        }
                  },
                  ver(v){
                        this.disabled = true;
                        var error = 'E';
                        var o = _.merge({opcion:'L_BENE_X_CER'},_.pick(v,['idCertificado','idPoliza']));

                        this.listGeneral.detalleModal = [];
                        axios.post(`${BASE_URI}administrador/asignacion-beneficio-complementario/listar`,o)
                              .then((r) =>{
                                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                    if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                          this.obModal = {
                                                open: true,
                                                titulo: `Beneficios de ${v.asegurado}`,
                                                search:''
                                          }
                                          this.listGeneral.detalleModal = r.data.data;
                                          this.disabled = false;
                              })
                              .catch((e) =>{
                                    this.disabled = false;
                                    mensajesAlerta(e, error);
                              });
                  },
                  enviar(){
                        try {
                              if(_.size(this.listDetalle) == 0) throw 'Debe seleccionar al menor un registro';
                              if(_.size(this.validTotalItems)) throw `Cantidad seleccionada excedida, ${this.obSearch.nroAsegurados} registros de ${_.size(this.listDetalle)} que tiene disponibles.`;
                                    this.disabled = true;
                                    var error = 'E';
                                    var o = _.merge(_.omit(this.obSearch,['search','nroAsegurados']),{'numeroMaxAsegurados':this.obSearch.nroAsegurados,'listDetalle':this.listDetalle});

                                    axios.post(`${BASE_URI}administrador/asignacion-beneficio-complementario/insertOrUpdate`,o)
                                         .then((r) =>{
                                                if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                                                if(_.size(_.get(r,['data','data'],[])) == 0) { error="I"; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion)};
                                                      mensajeAlertaTiempo(r.data.mensaje,'S');
                                                      this.onListarCertificados('L');
                                          })
                                          .catch((e) =>{
                                                this.disabled = false;
                                                mensajesAlerta(e, error);
                                          });
                        } catch (ex) {
                              this.disabled = false;
                              mensajesAlerta(ex, 'I');
                        }
                  },
                  close(band){
                        this.obModal = {
                              open:band,
                              titulo:'',
                              search:''
                        }
                  }
            },
            provide(){
                  return{
                        close:this.close
                  }
            }
      }
</script>